import { render, staticRenderFns } from "./CreditorDetails.vue?vue&type=template&id=21762fc8"
import script from "./CreditorDetails.vue?vue&type=script&lang=js"
export * from "./CreditorDetails.vue?vue&type=script&lang=js"
import style0 from "./CreditorDetails.vue?vue&type=style&index=0&id=21762fc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports